import React from 'react';
import Skeleton from '../../../../core/components/Skeleton';

const FeedDetailSkeleton = (): JSX.Element => {
    return (
        <>
            <section className="feed-info-section panel-spacing">
                <h3>Information</h3>

                <div className="info-row">
                    <div className="info-group">
                        <label>Type:</label>
                        <Skeleton width="80px" />
                    </div>
                    <div className="info-group">
                        <label>File Status:</label>
                        <Skeleton width="70px" />
                    </div>
                    <div className="info-group">
                        <label>Direction:</label>
                        <Skeleton width="40px" />
                    </div>
                    <div className="info-group">
                        <label>Verity Processed:</label>
                        <Skeleton width="130px" />
                    </div>
                </div>

                <div className="info-row">
                    <div className="info-group">
                        <label>Source:</label>
                        <Skeleton width="90px" />
                    </div>
                    <div className="info-group">
                        <label>Facility:</label>
                        <Skeleton width="100px" />
                    </div>
                    <div className="info-group">
                        <label>Pharmacy:</label>
                        <Skeleton width="100px" />
                    </div>
                </div>

                <div className="info-row">
                    <div className="info-group">
                        <label>Sender Id:</label>
                        <Skeleton width="80px" />
                    </div>
                    <div className="info-group">
                        <label>Receiver Id:</label>
                        <Skeleton width="80px" />
                    </div>
                    <div className="info-group">
                        <label>Vendor Account:</label>
                        <Skeleton width="90px" />
                    </div>
                </div>

                <div className="info-row">
                    <div className="info-group full-width">
                        <label>File Name:</label>
                        <Skeleton width="250px" />
                    </div>
                </div>
            </section>

            <section className="parsing-totals-section panel-spacing">
                <h3>Parsing Totals</h3>
                <div className="totals-row">
                    <div className="total-item">
                        <label>Received:</label>
                        <Skeleton width="45px" />
                    </div>
                    <div className="total-item">
                        <label>Processed:</label>
                        <Skeleton width="45px" />
                    </div>
                    <div className="total-item">
                        <label>Duplicate:</label>
                        <Skeleton width="45px" />
                    </div>
                    <div className="total-item">
                        <label>Rejected:</label>
                        <Skeleton width="45px" />
                    </div>
                    <div className="total-item">
                        <label>Errors:</label>
                        <Skeleton width="45px" />
                    </div>
                </div>
            </section>
        </>
    );
};

export default FeedDetailSkeleton;
